module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0049.jpg?v=66df28c1";